var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('router-link',{staticClass:"metabase-button",attrs:{"to":{
    name: 'MetabaseApplication'
  }}},[_c('icon',{attrs:{"glyph":"customer-intelligence"}}),_vm._v("\n  Intelligence\n")],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-856bff48","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/navigation/TopToolbarMetabaseLink.vue
// module id = null
// module chunks = 